import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import classNames from 'classnames';
import cookie from 'js-cookie';
import { t } from 'ttag';

import { I18NProvider, getClientLocale } from '@utils/i18n';

// styles
import s from './FavoritesLikesPopup.sss';

// types
type FavoritesLikesPopupProps = {
  className?: string;
  isOpen: boolean;
  onRequestClose: () => void;
  text: string;
  isSaved?: boolean;
  cookieName: string;
};

const EXPIRE_DAYS_COUNT = 3;
const FavoritesLikesPopupComponents: React.FC<FavoritesLikesPopupProps> = ({
  className,
  isOpen,
  onRequestClose,
  text,
  isSaved,
  cookieName,
}) => {
  const onClose = () => {
    onRequestClose();
    cookie.set(
      cookieName,
      '1',
      {
        expires: EXPIRE_DAYS_COUNT,
      },
    );
  };
  useEffect(() => {
    const timeOutClose = setTimeout(() => {
      onRequestClose();
      cookie.set(
        cookieName,
        '1',
        {
          expires: EXPIRE_DAYS_COUNT,
        },
      );
    }, 9000);
    return () => clearTimeout(timeOutClose);
  }, [cookieName, isOpen, onRequestClose]);
  return (
    (
      <div className={classNames(s.root, className, { [s.displayNone]: !isOpen })}>
        <div className={s.info}>
          {isSaved && (
          <p className={s.title}>Подпишитесь на поиск</p>
          )}
          <p>{text}</p>
        </div>
        <span
          className={s.okay}
          onClick={onClose}
        >
          {t`Добре`}
        </span>
      </div>
    )
  );
};

export const FavoritesLikesPopup: React.FC<FavoritesLikesPopupProps> = (props) => {
  const { lang, routerBasename } = getClientLocale();

  return (
    <BrowserRouter basename={routerBasename}>
      <I18NProvider lang={lang}>
        {
          () => <FavoritesLikesPopupComponents {...props} />
        }
      </I18NProvider>
    </BrowserRouter>
  );
};
